(() => {
  const enhanceContentPages = () => {
    document.querySelectorAll('[data-sv-content-page] .sv-content-page__prose table').forEach((table) => {
      if (table.parentElement?.classList.contains('sv-content-page__table-scroll')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'sv-content-page__table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('aria-label', 'Scrollable table');
      table.replaceWith(wrapper);
      wrapper.appendChild(table);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContentPages, { once: true });
  } else {
    enhanceContentPages();
  }
})();
